<template>
  <div class="mine-header-box">
    <div class="icon">
      <img :src="safeUsr.avatar && safeUsr.avatar.length > 0 ? safeUsr.avatar: require('../../../assets/images/headericon/headimg.png')" />
    </div>
    <div class="info">
      <p>{{ safeUsr.nickname }}</p>
      <span>ID: {{ safeUsr.id }} <a style="margin-left: 5px;color:#cca352;" @click="copy(safeUsr. id)">复制</a></span>
      <van-row class="progress">
        <van-col span="4">{{ safeUsr.current_vip }}</van-col>
        <van-col span="16" style="padding-top: 10px">
          <van-progress :percentage="bfNum" color="#cca352" />
        </van-col>
        <van-col span="4">{{ safeUsr.next_vip }}</van-col>
      </van-row>
    </div>
    <div class="arrow" @click="$router.push({ name: 'vip' })">
      <van-icon name="arrow" />
    </div>
     <div style="clear: both" />
  </div>
</template>

<script>
export default {
  name: 'MineHeadView',
  props:['usr','vip'],
  computed:{
    safeUsr(){
        return this.usr || {}
    },
    safeVip(){
        return this.vip || {}
    }
  },
  watch:{
    vip(){
       this.getbfNum()
    }
  },
  data(){
    return {
        bfNum:0
    }
  },
  methods:{
    getbfNum() {
      let num = 0; 
      this.safeVip.forEach((el, index) => {
        if (index == this.safeUsr.vip * 1) {
          num = el.recharge * 1;
        }
      });
      let userMey = this.safeUsr.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100) ;
      this.bfNum = bfNum > 100 ? 100 : bfNum ;
    },
    copy (val) {
      var input = document.createElement('input')
      input.value = val
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      this.$toast.success('复制成功')
      document.body.removeChild(input)
    },
  }
}
</script>
<style lang="scss" scoped>
.mine-header-box {
  color: #fff !important;
  position: relative;
  background: linear-gradient(to bottom, #270e33, #18103d);
            transition: all 0.3s ease;
  padding: 15px 25px;
  .icon {
    float: left;
    width: 1.6rem;
    height: 1.6rem;
    margin-top: 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .info {
    width: calc(100% - 2.2rem);
    float: left;
    text-align: left;
    line-height: 1.4;
    margin-left: 8px;
    p {
      font-size: 0.6rem;
      font-weight: 700;
    }
    .progress {
      text-align: center;
    }
  }
  .arrow {
    position: absolute;
    right: 10px;
    top: 1.35rem;
    color: #cca352;
  }
}
</style>
